import * as React from 'react';

import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';

import { Button } from 'antd';
import { useFullscreen } from '@/hooks/useFullscreen';
import { useTranslation } from 'react-i18next';

interface FullscreenButtonProps {

}

export const FullscreenButton: React.FC<FullscreenButtonProps> = (props) => {
    const { t } = useTranslation();
    const fullscreen = useFullscreen();

    if (!fullscreen.isFullscreenEnabled) {
        return null;
    }

    return (
        <Button
            type="default"
            style={{ width: '100%' }}
            icon={
                fullscreen.isFullscreenActive
                    ? <FullscreenExitOutlined />
                    : <FullscreenOutlined />
            }
            onClick={async () => {
                if (fullscreen.isFullscreenActive) {
                    await fullscreen.exitFullscreen();
                } else {
                    await fullscreen.requestFullscreen();
                }
            }}
        >
            {
                fullscreen.isFullscreenActive
                    ? t('Components.FullscreenButton.turn_off_fullscreen_button_text')
                    : t('Components.FullscreenButton.turn_on_fullscreen_button_text')
            }
        </Button>
    );
};